import { AtsMessageTemplateVisibilityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Visibility } from 'modules/ats/lib/enums'

export const messageTemplateVisibilityLabel = (visibility: AtsMessageTemplateVisibilityEnum) => {
  switch (visibility) {
    case Visibility.Company:
      return i18n.t('ats.manage_message_templates.visibility.company')

    case Visibility.Personal:
      return i18n.t('ats.manage_message_templates.visibility.personal')

    default:
      throw new Error(`Ats message template visibility: ${visibility} not valid`)
  }
}

export const isPersonal = (visibility: AtsMessageTemplateVisibilityEnum) =>
  visibility === Visibility.Personal
